module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJ4AAAAsAgMAAADp6emWAAAADFBMVEXt7v7s7f3////s7f0h6lg4AAAAA3RSTlPtkAbDbqgCAAAANklEQVQ4y2OY/J8Y8CeBof4/UeACgz1xCg8w/CcOfBhVOKpwVOGowlGFI0EhsdUH0RUS0VUcAGyq0cmAOsqbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/btn_bg1.png
// module id = dEEx
// module chunks = 167